import { RichTextEditor, type RichTextEditorHandle } from '@shared/components/atoms/RichTextEditor';
import DOMPurify from 'dompurify';
import type { Ref } from 'react';

interface WysiwygTextFieldProps {
  id?: string;
  className?: string | undefined;
  value: string | null;
  placeholder?: string;
  readOnly?: boolean;
  autoFocus?: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  ref?: Ref<RichTextEditorHandle>;
}

/**
 * Rich-text editor used across the app. Backed by TipTap (was Quill — replaced
 * to remediate CVE-2025-15056). Consumes/emits HTML so already-stored content
 * keeps rendering. Empty input is normalised to '' by the underlying editor so
 * `required` validators keep working.
 */
export const WysiwygTextField = ({
  id,
  className,
  value,
  placeholder,
  readOnly,
  autoFocus,
  onChange,
  onBlur,
  onKeyUp,
  ref,
}: WysiwygTextFieldProps) => (
  <RichTextEditor
    ref={ref}
    id={id}
    className={className}
    value={value ? DOMPurify.sanitize(value) : value}
    placeholder={placeholder}
    readOnly={readOnly}
    autoFocus={autoFocus}
    onChange={onChange}
    onBlur={onBlur}
    onKeyUp={onKeyUp}
  />
);
